import { FC, useCallback, useState } from 'react'
import { DataGrid, GridColDef, GridRenderCellParams, useGridApiRef } from '@mui/x-data-grid'
import { useGetRoomTypes } from '../../API'
import { makeStyles } from 'tss-react/mui'
import { useTranslation } from 'react-i18next'
import { Box, Button, IconButton } from '@mui/material'
import CreateNewRoomType from './CreateNewRoomType'
import { DeleteOutline, Edit, Settings, DoorSliding, Home } from '@mui/icons-material'
import DeleteRoomType from './DeleteRoomType'

const useStyles = makeStyles()(({ spacing }) => ({
  box: {
    margin: spacing(0.5),
  },
}))

const RoomTypes: FC = () => {
  const { t } = useTranslation('')
  const { classes } = useStyles()

  const dataGridRef = useGridApiRef()

  const [openCreate, setOpenCreate] = useState<number | null>(null)
  const [openDelete, setOpenDelete] = useState<number | null>(null)

  const roomTypesData = useGetRoomTypes()

  const handleClickOpenCreate = useCallback((roomTypeId: number) => {
    setOpenCreate(roomTypeId)
  }, [])

  const handleClickCloseCreate = useCallback(() => {
    setOpenCreate(null)
  }, [])

  const handleClickOpenDelete = useCallback((roomTypeId: number) => {
    setOpenDelete(roomTypeId)
  }, [])

  const handleClickCloseDelete = useCallback(() => {
    setOpenDelete(null)
  }, [])

  const columns: GridColDef[] = [
    { field: 'id', headerName: 'ID', width: 70 },
    { field: 'roomTypeName', headerName: 'Telpas nosaukums', width: 140 },
    {
      field: 'technicalRoom',
      headerName: 'Telpas tips',
      width: 120,
      renderCell: (params: GridRenderCellParams) => {
        return (
          <>
            {params.row.technicalRoom ? <Settings /> : null}
            {params.row.publicDoor ? <DoorSliding /> : null}
            {!params.row.technicalRoom && !params.row.publicDoor ? <Home /> : null}
          </>
        )
      },
    },
    {
      field: 'actions',
      headerName: '',
      type: 'number',
      width: 100,
      renderCell: (params: GridRenderCellParams) => {
        return (
          <>
            <IconButton
              color='success'
              component='div'
              sx={{}}
              onClick={() => {
                handleClickOpenCreate(params.row.id)
              }}
            >
              <Edit />
            </IconButton>
            <IconButton
              color='error'
              component='div'
              sx={{}}
              onClick={() => {
                handleClickOpenDelete(params.row.id)
              }}
            >
              <DeleteOutline />
            </IconButton>
          </>
        )
      },
    },
  ]

  return (
    <>
      <Box
        sx={
          {
            //display: 'flex',
            //flexWrap: 'wrap',
            //maxWidth: 300,
          }
        }
      >
        <Box className={classes.box}>
          <DataGrid
            apiRef={dataGridRef}
            rows={roomTypesData}
            columns={columns}
            rowSelection={false}
            disableColumnMenu={true}
            hideFooter={true}
            autoHeight={true}
            initialState={{
              pagination: {
                paginationModel: { page: 0, pageSize: 100 },
              },
            }}
            pageSizeOptions={[50, 10]}
          />
        </Box>
        <Box className={classes.box}>
          <Button variant='outlined' size={'small'} onClick={() => handleClickOpenCreate(0)}>
            {t('Pievienot jaunu telpu')}
          </Button>
        </Box>
      </Box>

      {openCreate !== null && (
        <CreateNewRoomType
          dataGridRef={dataGridRef}
          handleClickClose={handleClickCloseCreate}
          roomTypesData={roomTypesData}
          id={openCreate}
        />
      )}

      {openDelete && (
        <DeleteRoomType
          dataGridRef={dataGridRef}
          handleClickClose={handleClickCloseDelete}
          roomTypesData={roomTypesData}
          id={openDelete}
        />
      )}
    </>
  )
}

export default RoomTypes
